import ActivatePage from '@/pages/account/activate/ActivatePage.vue';
import LoginPage from '@/pages/account/login/LoginPage.vue';
import OtpLoginPage from '@/pages/account/login/OtpLoginPage.vue';

export default [
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/otp',
    name: 'OtpLogin',
    component: OtpLoginPage
  },
  {
    path: '/account/activate',
    name: 'Activate',
    component: ActivatePage
  }
];
